import type { ReactElement } from 'react';
import { Envelope } from '../streamlineSolidIcon/Envelope';
import { StandardButton, type StandardButtonProps } from './StandardButton';

export interface ContactSupportButtonProps
  extends Omit<StandardButtonProps, 'startIcon' | 'endIcon'> {}

export const ContactSupportButton = ({
  text,
  ...props
}: ContactSupportButtonProps): ReactElement => (
  <StandardButton
    variant="contained"
    color="black"
    size="large"
    text={text ?? 'Contact support'}
    startIcon={<Envelope />}
    {...props}
  />
);
